import React from "react";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller.js";
import Frame from "../../../../../Frame/index.js";
import { Text } from "@bookingcom/bui-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
import { UpgradeFareInfoDesktop } from "./UpgradeFareInfo.desktop.js";
const useUpgradeFareInfoDesktop = (flight) => {
    const data = useUpgradeFareInfoController(flight);
    const { header, subheader, fareInfoContent } = data;
    const { isMobile, isDesktop } = useProfiler();
    if (!fareInfoContent)
        return undefined;
    return {
        header,
        subheader,
        content: isMobile() &&
            !!track("flights_funnel_new_fd_page_mobile") ? undefined : isDesktop() &&
            !!track("flights_funnel_new_fd_page_desktop") ? (React.createElement(UpgradeFareInfoDesktop, { ...data })) : (React.createElement(Frame, { direction: "row", justifyContent: "space-between" },
            React.createElement(Frame, null,
                React.createElement(Text, { variant: "body_2" }, fareInfoContent.content),
                React.createElement(Text, { variant: "body_2" }, fareInfoContent.price)),
            React.createElement(Frame, { ml: 4 },
                React.createElement(Text, { variant: "body_2", align: "end", wrap: "nowrap" }, fareInfoContent.supportText))))
    };
};
export default useUpgradeFareInfoDesktop;
